import { ChangeDetectionStrategy, Component, input, output } from '@angular/core';

import { ButtonComponent } from '../../atoms/button/button.component';
import { BackgroundGlowComponent } from '../background-glow/background-glow.component';
import { EmptyStateComponent } from '../empty-state/empty-state.component';

/**
 * Full-screen fatal error for when the app loaded but a crucial dependency (e.g. sign-in)
 * couldn't start — instead of a blank page, it explains and offers one way back in.
 */
@Component({
  selector: 'esn-app-error',
  imports: [BackgroundGlowComponent, ButtonComponent, EmptyStateComponent],
  templateUrl: './app-error.component.html',
  styleUrl: './app-error.component.css',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AppErrorComponent {
  readonly title = input('Something went wrong');
  readonly message = input("We couldn't start the app. This is usually temporary — please try again.");

  /**
   * Optional technical error text, tucked behind a collapsed disclosure.
   */
  readonly detail = input<string | null>(null);

  readonly detailsLabel = input('Technical details');
  readonly retryLabel = input('Try again');

  readonly retry = output<void>();
}
